import React from 'react';
import { renderSkuWithSoftBreaks } from '../../../utils/skuSoftBreak';
import { formatBundlesToMakeLabel } from './bundleWorkOrderLogic';

interface BundleWorkReadySheetProps {
  readonly parentSku: string;
  readonly bundlesToMake: number;
}

function BundleWorkReadySheet({
  parentSku,
  bundlesToMake,
}: BundleWorkReadySheetProps): React.ReactElement {
  return (
    <div className="bundle-work-ready-copy">
      <p className="bundle-work-ready-sku">{renderSkuWithSoftBreaks(parentSku)}</p>
      <hr className="bundle-work-ready-divider" />
      <p className="bundle-work-ready-count">{formatBundlesToMakeLabel(bundlesToMake)}</p>
    </div>
  );
}

export default BundleWorkReadySheet;
